import React from 'react';

import { Tfoot } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledTFoot = styled(Tfoot)`
  background: ${(props) => props.theme.colors.common.white};
  & td {
    border-radius: 0 0 4px 4px;
  }
`;

const TableFoot = ({ children, ...props }) => <StyledTFoot {...props}>{children}</StyledTFoot>;

export { TableFoot };
